module.exports = __webpack_public_path__ + "img/broadcast-bg.png";